import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MatSnackBar, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CoreService } from '../core.service';
import { CondicionesDialogComponent } from '../../shared/components/condiciones-dialog/condiciones-dialog.component';
import { UsuarioLogin } from '../../shared/models/UsuarioLogin';
import { UsuarioAutenticado } from '../../shared/models/UsuarioAutenticado';
import { SharedService } from '../../shared/shared.service';
import { ResetPasswordRequestComponent } from '../components/reset-password-request/reset-password-request.component';

@Component({
  selector: 'app-identificate',
  templateUrl: './identificate.component.html',
  styleUrls: ['./identificate.component.css']
})
export class IdentificateComponent implements OnInit {

  loginForm: FormGroup;
  dialogCondiciones: MatDialogRef<CondicionesDialogComponent>;
  link: string;
  constructor(private fb: FormBuilder, private router: Router, public http: HttpClient, public coreService: CoreService,
    public dialog: MatDialog, public snackBar: MatSnackBar, private sharedService: SharedService) {
    this.coreService.setTitle("Identificación | Instituto Lactológico de Lekunberri");
    if (coreService.isLoggedIn()) {
      this.router.navigateByUrl('/menu');
    }
    this.loginForm = this.createForm(fb);
  }

  ngOnInit() {
  }

  get user() { return this.loginForm.get('user'); }

  get password() { return this.loginForm.get('password'); }

  createForm(formBuilder: FormBuilder) {
    return formBuilder.group({
      user: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  onSubmit() {
    this.sharedService.loadingBehaviorSubject.next(true);
    let user = new UsuarioLogin(this.loginForm.get('user').value, this.loginForm.get('password').value);
    this.coreService.login(user).subscribe(res => {
      if (this.coreService.isLoggedIn()) {
        //Redirect al menu privado.
        this.snackBar.open(res.message, "x", { panelClass: ['success-snackbar'], duration: 2000 });
        this.router.navigateByUrl('/menu/resultados');
      } else {
        //Mostramos el snackbar de error
        this.snackBar.open(res.message, "x", { panelClass: ['error-snackbar'], duration: 2000 });
      }
      this.sharedService.loadingBehaviorSubject.next(false);
    });
  }

  recuperarContrasena() {
    const dialogRef = this.dialog.open(ResetPasswordRequestComponent, {
      width: 'auto'
    });

    dialogRef.afterClosed().subscribe(result => {
      
      if (result) {
        this.sharedService.loadingBehaviorSubject.next(true);
        let email: string = result;
        
        this.coreService.sendRecoveryEmail(email).subscribe(respuesta => {
          if (respuesta.response_code > 0) {
            this.snackBar.open(respuesta.message, '', { duration: 10000, panelClass: ["success-snackbar"] });
          } else {
            this.snackBar.open(respuesta.message, "x", { panelClass: ["error-snackbar"] });
          }
          this.sharedService.loadingBehaviorSubject.next(false);
        });
      }
      
    });
  }
}

